import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';

interface RelatorioBaseFaturamentoBtnProps {
    disabled: boolean;
}

export function RelatorioFaturamentoFppBtn({ disabled }: RelatorioBaseFaturamentoBtnProps) {
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/financeiro/fpp/extrato/faturamento',
            columns: 'idRelatorioFinanceiroFaturamentoFpp',
            filter,
        }),
        [filter],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleRelatorioBaseFaturamentoXls = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            color="success"
            onClick={handleRelatorioBaseFaturamentoXls}
            disabled={disabled || isLoadingFile}
            startIcon={<RiFileExcel2Fill />}
        >
            Relatório Base Faturamento FPP
        </Button>
    );
}
